import type { IForgotPasswordData } from "@frontend-shared/types";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { authApi } from "@/api/services";

export const useForgotPassword = () => {
  const { t } = useTranslation("auth");

  return useMutation({
    mutationFn: (params: IForgotPasswordData) => authApi.forgotPassword(params),
    meta: {
      fallbackMessage: t("forgot_password.error"),
    },
  });
};
